'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'pen-nib';
var width = 576;
var height = 512;
var aliases = [10001];
var unicode = 'f5ad';
var svgPathData = 'M428.7 198.1l86.1-86.1-82.7-82.7-86.1 86.1 82.7 82.7zM413 227.7L316.3 131 153.7 185.2 72.6 448.7 184.9 336.5c-5.6-9.5-8.9-20.6-8.9-32.5 0-35.3 28.7-64 64-64s64 28.7 64 64-28.7 64-64 64c-11.9 0-23-3.2-32.5-8.9L95.3 471.4 358.9 390.3 413 227.7zM384 416l-312 96-40-40 96-312 192-64c70.7-70.7 108-108 112-112 5.1 5.1 40.2 40.2 105.4 105.4L560 112c-4 4-41.3 41.3-112 112L384 416zM208 304a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPenNib = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;